import { z } from 'zod'
import { uuidSchema } from './common'

// Agent type enum
export const agentTypeSchema = z.enum(['HR', 'OPS'])

// Message role enum
export const messageRoleSchema = z.enum(['USER', 'ASSISTANT', 'SYSTEM'])

// Chat session schemas
export const chatSessionSchema = z.object({
  id: uuidSchema,
  userId: uuidSchema,
  agentType: agentTypeSchema,
  createdAt: z.date(),
  updatedAt: z.date()
})

export const createChatSessionSchema = z.object({
  agentType: agentTypeSchema
})

// Message schemas
export const messageSchema = z.object({
  id: uuidSchema,
  sessionId: uuidSchema,
  role: messageRoleSchema,
  content: z.string().min(1).max(10000),
  metadata: z.record(z.string(), z.any()).nullable(),
  createdAt: z.date()
})

export const createMessageSchema = z.object({
  sessionId: uuidSchema,
  role: messageRoleSchema,
  content: z.string().min(1).max(10000),
  metadata: z.record(z.string(), z.any()).optional()
})

export const chatQuerySchema = z.object({
  agentType: agentTypeSchema.optional(),
  startDate: z.string().datetime().optional(),
  endDate: z.string().datetime().optional(),
  search: z.string().optional()
})

export const messageQuerySchema = z.object({
  sessionId: uuidSchema,
  role: messageRoleSchema.optional(),
  limit: z.number().int().min(1).max(100).default(50),
  offset: z.number().int().min(0).default(0)
})

export const chatRequestSchema = z.object({
  message: z.string().min(1).max(10000),
  sessionId: uuidSchema.optional(),
  agentType: agentTypeSchema,
  context: z.record(z.string(), z.any()).optional()
})

// Type exports - using different names to avoid conflicts
export type ChatSessionData = z.infer<typeof chatSessionSchema>
export type CreateChatSessionData = z.infer<typeof createChatSessionSchema>
export type MessageData = z.infer<typeof messageSchema>
export type CreateMessageData = z.infer<typeof createMessageSchema>
export type ChatQueryData = z.infer<typeof chatQuerySchema>
export type MessageQueryData = z.infer<typeof messageQuerySchema>
export type ChatRequestData = z.infer<typeof chatRequestSchema>
export type AgentType = z.infer<typeof agentTypeSchema>
export type MessageRole = z.infer<typeof messageRoleSchema> 